export const GLOBAL__MUTATIONS = {
  SET_IS_LOADING: "SET_IS_LOADING",
  SET_COMMON_ERRORS: "SET_COMMON_ERRORS",
};

export const MODAL__MUTATIONS = {
  SET_IS_OPEN: "SET_IS_OPEN",
};

export const LOGOUT__DIALOG__MUTATIONS = {
  SHOW_DIALOG: "SHOW_DIALOG",
  HIDE_DIALOG: "HIDE_DIALOG",
};

export const AUTHENTICATION__MUTATIONS = {
  LOGIN_EMAIL: "LOGIN_EMAIL",
  RESET_EMAIL: "RESET_EMAIL",
  RESET_CODE: "RESET_CODE",
  RESET_ATTEMPT: "RESET_ATTEMPT",
  RESET_NEWPASS: "RESET_NEWPASS",
  RESET_REPEATPASS: "RESET_REPEATPASS",
  SEND_EMAIL_TO: "SEND_EMAIL_TO",
  LOGIN_PASSWORD: "LOGIN_PASSWORD",
  TOKEN: "TOKEN",
  REMOVE_TOKEN: "REMOVE_TOKEN",
  CLIENT: "CLIENT",
  REGISTER_ACCOUNT_TYPE: "REGISTER_ACCOUNT_TYPE",
  REGISTER_FNAME: "REGISTER_FNAME",
  REGISTER_LNAME: "REGISTER_LNAME",
  REGISTER_EMAIL: "REGISTER_EMAIL",
  REGISTER_PASSWORD: "REGISTER_PASSWORD",
  REGISTER_CONFIRM_PASSWORD: "REGISTER_CONFIRM_PASSWORD",
  RESET_REGISTER_INFO: "RESET_REGISTER_INFO",
  RESET_LOGIN_INFO: "RESET_LOGIN_INFO",
  SOCIAL_LOGIN_EMAIL: "SOCIAL_LOGIN_EMAIL",
  API_LOGIN_FLAG: "API_LOGIN_FLAG",
  VIEW_PASSWORD: "VIEW_PASSWORD",
  CREATEDTIME: "CREATEDTIME",
  REGISTER_OTP: "REGISTER_OTP",
  USER_OTP: "USER_OTP",
  SENDREGISTEROTP: "SENDREGISTEROTP",
  FORGETPASSWORDCODE: "FORGETPASSWORDCODE",
  UPDATESTEPPER: "UPDATESTEPPER",
  CHANGESTEP: "CHANGESTEP",
  CHANGEPASSWORDSTEP: "CHANGEPASSWORDSTEP",
};

export const DASHBOARD__MUTATIONS = {
  PARTNERSUMMARY: "PARTNERSUMMARY",
};

export const PARTNERCOMMISSION__MUTATIONS = {
  PARTNERCOMMISSIONSTATISTICS: "PARTNERCOMMISSIONSTATISTICS",
  PARTNERCOMMISSIONWITHDRAWAL: "PARTNERCOMMISSIONWITHDRAWAL",
  PARTNERTRANSFER: "PARTNERTRANSFER",
};

export const PROFILE__MUTATIONS = {
  PROFILE: "PROFILE",
  IDENTITYVERIFICATION: "IDENTITYVERIFICATION",
  RESIDENCEVERIFICATION: "RESIDENCEVERIFICATION",
  IDENTITYVERIFICATIONDOCUMENTS: "IDENTITYVERIFICATIONDOCUMENTS",
  RESIDENCEVERIFICATIONDOCUMENTS: "RESIDENCEVERIFICATIONDOCUMENTS",
  GETTUTORIALS: "GETTUTORIALS"
};

export const TRADINGHISTORY__MUTATIONS = {
  CLIENTLIVETRADESREPORTS: "CLIENTLIVETRADESREPORTS",
  CLIENTCLOSEDTRADESREPORTS: "CLIENTCLOSEDTRADESREPORTS",
};

export const TRADINGACCTYPES__MUTATIONS = {
  TRADINGACCTYPES: "TRADINGACCTYPES",
};

export const CLIENTTRANSACTIONREPORTS__MUTATIONS = {
  TRANSACTIONREPORTS: "TRANSACTIONREPORTS",
};

export const FAQS__MUTATIONS = {
  FAQS: "FAQS",
};

export const COMPANYINFO__MUTATIONS = {
  COMPANYINFO: "COMPANYINFO",
};

export const AGREEMENT__MUTATIONS = {
  NOTACCEPTEDAGREEMENTS: "NOTACCEPTEDAGREEMENTS",
  AGREEMENTHISTORIES: "AGREEMENTHISTORIES",
  UPLOADAGREEMENTFILE: "UPLOADAGREEMENTFILE",
};

export const ALLACCOUNTSSUMMARY__MUTATIONS = {
  ALLACCOUNTSSUMMARY: "ALLACCOUNTSSUMMARY",
  CLINTSSUMMARY: "CLINTSSUMMARY",
};

export const CLIENTTREE__MUTATIONS = {
  CLIENTTREE: "CLIENTTREE",
};
export const DRONEVIEW__MUTATIONS = {
  DRONEVIEW: "DRONEVIEW",
};

export const PARTNERPROFILE__MUTATIONS = {
  PARTNERPROFILE: "PARTNERPROFILE",
};

export const PAYMENTMETHODS__MUTATIONS = {
  PAYMENTMETHODS: "PAYMENTMETHODS",
};

export const TRADINGACCOUNTSTOTRANSFER__MUTATIONS = {
  TRADINGACCOUNTSTOTRANSFER: "TRADINGACCOUNTSTOTRANSFER",
  INTERNALTRANSFERSENDOTP: "INTERNALTRANSFERSENDOTP",
  CONFIRMINTERNALTRANSFER: "CONFIRMINTERNALTRANSFER",
  BANKTRANSFERSENDOTP: "BANKTRANSFERSENDOTP",
  CONFIRMBANKTRANSFER: "CONFIRMBANKTRANSFER",
  CLIENTLEVELEARNINGS: "CLIENTLEVELEARNINGS",

  //crypto tranfer
  ALLCRYPTOADDRESS: "ALLCRYPTOADDRESS",
  TRANSFERTOCRYPTOSENDOTP: "TRANSFERTOCRYPTOSENDOTP",
  CONFIRMTRANSFERTOCRYPTO: "CONFIRMTRANSFERTOCRYPTO",
   //all tranfer
  ALLBANKADDRESS: "ALLBANKADDRESS",
};

export const COMMISSIONSTATS__MUTATIONS = {
  COMMISSIONSTATS: "COMMISSIONSTATS",
  LEVELWISECOMMISSIONEARNING: "LEVELWISECOMMISSIONEARNING",
};

export const MARKETTINGTOOLS__MUTATIONS = {
  BANNERCATEGORIES: "BANNERCATEGORIES",
  BANNERSIZES: "BANNERSIZES",
  BANNERS: "BANNERS",
  CREATEBANNER: "CREATEBANNER",
  UPDATEBANNER: "UPDATEBANNER",
  DELETEBANNER: "DELETEBANNER",
  BANNERSIZECREATE: "BANNERSIZECREATE",
  BANNERSIZEUPDATE: "BANNERSIZEUPDATE",
  BANNERSIZEDELETE: "BANNERSIZEDELETE",
};


export const NOTIFICATIONS__MUTATIONS = {
  NOTIFICATIONS: "NOTIFICATIONS",
  SET_POLLING_INTERVAL: "SET_POLLING_INTERVAL",
  STOP_POLLING_INTERVAL: "STOP_POLLING_INTERVAL"
};

export const ASSACCTYPES__MUTATIONS = {
  ASSIGNEDACCTYPES: "ASSIGNEDACCTYPES",
  ASSIGNEDACCTYPESBOOK: "ASSIGNEDACCTYPESBOOK",
  CURRENCYGROUPS: "CURRENCYGROUPS",
  COMRATRESTREE: "COMRATRESTREE",
  VIEWCOMRATRES: "VIEWCOMRATRES",
};

export const PUBLIC_LOGIN__MUTATIONS = {
  LOGINPAGEINFO: "LOGINPAGEINFO",
};

export const TRADEMASTER__MUTATIONS = {
  INVESTORACCOUNTS: "INVESTORACCOUNTS",
  AFFILIATESUMMARY: "AFFILIATESUMMARY",
  MT5ACCOUNTDETAILS: "MT5ACCOUNTDETAILS",
  LEVELCLIENTS: "LEVELCLIENTS",
  MT5TRANSACTIONS: "MT5TRANSACTIONS"
}